export default "__VITE_ASSET__YceULUFp__"